import React, { useState } from "react";
import { LayoutGroup, motion } from "framer-motion";
import type { AnswerState, RearrangeExercise } from "../../types/exercises";
import { shuffle } from "../../utils/text";
import { spring } from "../../utils/motion";
interface RearrangeProps {
  exercise: RearrangeExercise;
  onAnswer: (a: AnswerState) => void;
  checked: boolean;
}
interface Chip {
  id: string;
  word: string;
}
const chipClass = "focus-ring rounded-xl border-3 border-line px-3.5 py-2 text-[17px] font-semibold shadow-brutal-sm";
export function Rearrange({
  exercise,
  onAnswer,
  checked
}: RearrangeProps) {
  const [bank] = useState<Chip[]>(() => shuffle([...exercise.answer, ...exercise.distractors]).map((w, i) => ({
    id: `c${i}`,
    word: w
  })));
  const [placed, setPlaced] = useState<string[]>([]);
  const solution = exercise.answer.join(" ");
  const update = (next: string[]) => {
    setPlaced(next);
    const sentence = next.map(id => bank.find(c => c.id === id)!.word).join(" ");
    onAnswer({
      ready: next.length > 0,
      correct: sentence === solution,
      solution
    });
  };
  const sentence = placed.map(id => bank.find(c => c.id === id)!.word).join(" ");
  const isCorrect = sentence === solution;
  return <LayoutGroup data-id="element-424" data-mp="2hzs32nh6wnsx">
      <p className="mb-5 text-[17px] text-ink-2" data-id="element-425" data-mp="2i09xdekakry7">
        Translate: <span className="font-semibold text-ink" data-id="element-426" data-mp="2d77cdutkyqtm">{exercise.translation}</span>
      </p>
      <div className={`pat-ruled flex min-h-[132px] flex-wrap content-start gap-2.5 rounded-card border-3 border-line p-4 ${checked ? isCorrect ? "bg-good-tint" : "bg-bad-tint" : "bg-surface"}`} aria-label="Your sentence" lang="es" data-id="element-427" data-mp="2rwmxovace41x">
        {placed.length === 0 && <span className="self-center text-[15px] text-ink-2" data-id="element-428" data-mp="2wxapvkab4qxq">Tap words below to build the sentence</span>}
        {placed.map(id => {
        const chip = bank.find(c => c.id === id)!;
        return <motion.button key={id} layoutId={id} type="button" disabled={checked} transition={spring.smooth} onClick={() => update(placed.filter(p => p !== id))} className={`${chipClass} bg-surface text-ink`} data-id="element-429" data-mp="12jjhsp7mmf4e">
              {chip.word}
            </motion.button>;
      })}
      </div>

      <ul className="mt-6 flex flex-wrap justify-center gap-2.5" aria-label="Word bank" lang="es" data-id="element-430" data-mp="3gltttvmkbv4e">
        {bank.map(c => <li key={c.id} data-id="element-431" data-mp="3kjzvip8jnkig">
            {placed.includes(c.id) ? <span className={`${chipClass} block border-dashed border-line/30 bg-transparent text-transparent shadow-none`} data-id="element-432" data-mp="3pjckpgmw13o7">{c.word}</span> : <motion.button layoutId={c.id} type="button" disabled={checked} whileTap={{
          scale: 0.95
        }} transition={spring.smooth} onClick={() => update([...placed, c.id])} className={`${chipClass} bg-surface text-ink`} data-id="element-433" data-mp="35vuvl7rjeuh">
                {c.word}
              </motion.button>}
          </li>)}
      </ul>
    </LayoutGroup>;
}